import { memo } from 'react';

import AddActionButton from './AddActionButton';

function AddGroupComponent({ handleOnClick }) {
  return <AddActionButton handleOnClick={handleOnClick}>Add rule</AddActionButton>;
}

export default memo(AddGroupComponent);
